/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class LiveWidgetInternalAPI
 * @hideconstructor
 * @classdesc Internal API class that is used to return widget/visview related
 */
define([], () => {
	class LiveWidgetInternalAPI {

		/**
		 * @function LiveWidgetInternalAPI#getWidget
		 * @description Get the widget
		 * @return {Widget} Internal ID of the widget
		 */
		getWidget() {}

		/**
		 * @function LiveWidgetInternalAPI#getVisView
		 * @description Get the current view
		 * @return {visview} The type of the cansas content
		 */
		getVisView() {}

	}

	return LiveWidgetInternalAPI;
});
